
    
    //namespaced: true,
    const  initFilter={
      current_tab:"",
      manulSelectedTab:"",
      filterData:{
      owners:[],
      contracts:[],
      groups: [],
      types:[],
      device_categories:"",
     
      }

}
const windowFoucs=true;

const initialState = () => {
  return  Object.assign({}, initFilter)
  
}
const state = initialState()
const  actions= {
   setDashBoardFilterData (ctx, params) {   
    
    
      ctx.commit('setDashBoardFilterData',params);  
    
  },
  setDashboardCurrentTab(ctx,val){
    ctx.commit('setDashboardCurrentTab',val);  
  },
  setWindowFoucs(ctx,val){
    ctx.commit('setWindowFoucs',val)
  },
  setManulSelectedTab(ctx,val){
    ctx.commit('setManulSelectedTab',val)
  }
  

}
const mutations={
  setDashBoardFilterData:(state,data)=>{  
     Object.assign(state.filterData,data)
    },

    setDashboardCurrentTab:(state,val)=>{
       state.current_tab=val;
    },

    setWindowFoucs(state,data){
     
      state.windowFoucs=data;
    },
    setManulSelectedTab(state,data){
      state.manulSelectedTab=data;
    }

 

}
const getters={
getFilterData(state) {
  
return state.filterData
},
getCurrentTab(state){

  return state.current_tab;
},
getWindowFoucs(state){
 return windowFoucs;
},
getManulSelectedTab(state){
  return state.manulSelectedTab;
}
}








export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};